const Input = {
  baseStyle: {
    field: {
      color: "midGray",
      fontWeight: "400",
      boxShadow: "0px 1px 2px 0px #0000000D",
      _placeholder: {
        color: "midGray",
        fontSize: "12px",
        lineHeight: "24px",
        fontWeight: "400",
      },
    },
  },
  sizes: {
    sm: {
      field: {
        fontSize: "12px",
        lineHeight: "24px",
        h: "40px",
        borderRadius: "6px",
      },
    },
    md: {
      field: {
        fontSize: "14px",
        lineHeight: "24px",
        h: "40px",
        borderRadius: "6px",
      },
    },
  },
};

export default Input;
